import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";

class TypesTags extends Component {
  static defaultProps = {
    enableAll: false,
    singleValue: false,
    selectedTypes: [],
    selectedTypeId: null,
    centered: false,
  };
  constructor(props) {
    super(props);

    this.state = this.setValues(props);
  }

  setValues = (props) => {
    if (props.enableAll) {
      return {
        values: this.props.allSlotTypes,
        existing: false,
        hourId: null,
      };
    } else if (props.selectedTypeId === null && !props.singleValue) {
      if (props.dayTemplate) {
        let h = props.dayTemplate.hours.filter((hour) => {
          return hour.time === props.hour;
        });
        if (h.length > 0) {
          return {
            existing: true,
            values: h[0].slotTypes,
            hourId: h[0].id,
          };
        } else {
          return {
            existing: false,
            values: [],
          };
        }
      }
      if (props.selectedTypes.length > 0) {
        return {
          values: props.selectedTypes,
        };
      } else {
        return {
          values: [],
        };
      }
    } else {
      return {
        values: [],
      };
    }
  };
  handleTypeTagChange = async () => {
    if (this.props.handleTypeTagChange) {
      if (this.props.singleValue) {
        this.props.handleTypeTagChange(this.state.values[0]);
      } else {
        this.props.handleTypeTagChange(this.state.values);
      }
    } else {
      if (this.state.existing) {
        const slotTypesIds = this.state.values.map((v) => v.id);
        const id = this.state.hourId;

        await this.props
          .updateHourMutation({
            variables: { id, slotTypesIds },
          })
          .catch((e) => {
            console.error("update hour", e);
          });
      } else {
        const slotTypesIds = this.state.values.map((v) => v.id);
        const time = this.props.hour;
        const dayTemplateId = this.props.dayTemplate.id;
        //save hour
        await this.props
          .createHourMutation({
            variables: { time, dayTemplateId, slotTypesIds },
          })
          .catch((e) => {
            console.error("createHourMutation: ", e);
          });
      }
    }
  };

  componentWillReceiveProps(newProps) {
    if (newProps.dayTemplate) {
      this.setState(this.setValues(newProps));
    }
    if (
      newProps.singleValue &&
      !newProps.allSlotTypes.find((s) => s.id === newProps.selectedTypeId)
    ) {
      this.setState({ values: newProps.selectedTypes });
    }
  }
  componentWillMount() {
    this.setValues(this.props);
  }
  disable = (id) => {
    if (this.props.singleValue) {
      this.setState({ values: [] }, this.handleTypeTagChange);
    } else {
      const newValues = this.state.values.filter((v) => v.id !== id);
      this.setState({ values: newValues }, this.handleTypeTagChange);
    }
  };
  enable = (slot) => {
    if (this.props.singleValue) {
      this.setState({ values: [slot] }, this.handleTypeTagChange);
    } else {
      this.setState(
        { values: [...this.state.values, slot] },
        this.handleTypeTagChange
      );
    }
  };
  enableAll = () => {
    this.setState(
      { values: this.props.allSlotTypes },
      this.handleTypeTagChange
    );
  };
  disableAll = () => {
    this.setState({ values: [] }, this.handleTypeTagChange);
  };
  render() {
    let types = this.props.allSlotTypes.map((slotType) => {
      if (slotType.role === "HIDDEN") {
        return null;
      }
      let found = false;
      if (this.props.selectedTypeId === slotType.id) {
        found = true;
      } else {
        found = this.state.values.find((v) => {
          return v.id === slotType.id;
        });
      }
      if (found) {
        return (
          <div className="tags has-addons" key={slotType.id}>
            <span
              className="tag is-success"
              onClick={() => this.disable(slotType.id)}
            >
              {slotType.name}
            </span>
          </div>
        );
      }
      return (
        <div className="tags has-addons" key={slotType.id}>
          <span
            onClick={() => this.enable(slotType)}
            className="tag is-disabled"
          >
            {slotType.name}
          </span>
        </div>
      );
    });
    let enableAll = (
      <div className="tags has-addons ">
        <a onClick={this.enableAll}>Tous</a>
      </div>
    );
    let disableAll = (
      <div className="tags has-addons">
        <a onClick={this.disableAll}>Aucun</a>
      </div>
    );

    return (
      <div
        className="types-tags"
        style={{
          alignItems: "center",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: this.props.centered ? "center" : "flex-start",
          padding: "0 2rem",
        }}
      >
        {!this.props.singleValue ? enableAll : null}
        {!this.props.singleValue ? disableAll : null}

        {types}
      </div>
    );
  }
}
const CREATE_HOUR_MUTATION = gql`
  mutation CreateHour(
    $time: String!
    $dayTemplateId: ID
    $slotTypesIds: [ID!]
  ) {
    createHour(
      time: $time
      dayTemplateId: $dayTemplateId
      slotTypesIds: $slotTypesIds
    ) {
      id
      time
    }
  }
`;

const UPDATE_HOUR_MUTATION = gql`
  mutation UpdateHourMutation($id: ID!, $slotTypesIds: [ID!]) {
    updateHour(id: $id, slotTypesIds: $slotTypesIds) {
      id
    }
  }
`;

export default compose(
  graphql(CREATE_HOUR_MUTATION, {
    name: "createHourMutation",
  }),
  graphql(UPDATE_HOUR_MUTATION, {
    name: "updateHourMutation",
  })
)(TypesTags);



// WEBPACK FOOTER //
// ./src/components/utilities/TypesTags.js